import * as React from 'react';
import { SVGProps } from 'react';

const SvgTags = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <g clipPath="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.618 3.088c0-1.196.97-2.165 2.164-2.165h3.566a5.73 5.73 0 0 1 5.729 5.73v10.695a5.73 5.73 0 0 1-5.73 5.729H6.653a5.73 5.73 0 0 1-5.73-5.73v-3.565c0-1.195.97-2.164 2.165-2.164h1.004a2.61 2.61 0 1 1 5.12 0h2.406V8.695a.382.382 0 0 1 .535-.35 1.846 1.846 0 1 0 0-3.385.382.382 0 0 1-.535-.35V3.088Zm0 9.294H8.695a.382.382 0 0 1-.35-.535 1.846 1.846 0 1 0-3.385 0 .382.382 0 0 1-.35.535H3.088a1.4 1.4 0 0 0-1.401 1.4v3.566a4.965 4.965 0 0 0 4.966 4.965h4.965v-2.405a2.61 2.61 0 1 1 0-5.12v-2.406Zm.764 9.931V19.39a.382.382 0 0 0-.535-.35 1.846 1.846 0 1 1 0-3.385.382.382 0 0 0 .535-.35v-2.923h2.405a2.61 2.61 0 1 0 5.12 0h2.406v4.966a4.966 4.966 0 0 1-4.965 4.965h-4.966Zm9.931-10.695H19.39a.382.382 0 0 0-.35.535 1.846 1.846 0 1 1-3.385 0 .382.382 0 0 0-.35-.535h-2.923V9.213a2.61 2.61 0 1 0 0-5.12V3.087a1.4 1.4 0 0 1 1.4-1.401h3.566a4.966 4.966 0 0 1 4.965 4.966v4.965Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={0.3}
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgTags;
